<template>
  <div class="page-wrapper" >
    <div class="container" v-if="pickup != ''">

      <div class="logo-row">
      <img src="@/assets/images/logo/NudgPay.png" alt="Nudg Logo" class="logo" />

      </div>
      <div class="content-row">

      <div class="left-column">
        <h1>Download The APP <span class="highlight">24/7</span></h1>
        <p class="note">
          Your Taxi, Booked, Dispatched & Delivered upon request at any time. We
          work round the clock to ensure you get to your destination as quick as
          possible.
        </p>
        <div v-if="!is_archived && payment_done_case" class="receipt-box">
          <input type="email" placeholder="Recipient's Email"  name="email" v-model="email" class="input-email">
          <button class="pay-now" @click="getReciept">Payment Receipt</button>
        </div>
      </div>


        <div class="right-column">
          <div class="card">
            <div class="heading-content-row ">
                <p class="heading-left-column">
                  Journey details
                </p>
                <div v-show="(!is_archived && !checkaccount)"  v-if="showEditing == true" class="heading-right-column">
                  <button  @click="editClick" class="track-btn edit-btn">Edit Booking</button>
                
                </div>
            </div>

            <div class="details">
              <p v-if="isAirportBooking && !checkaccount && !payment_done_case" class="upgrade-message">Upgrade your ride—more space, more comfort, more style. Executive vehicle available</p>
              <div class="row">
                <span class="label">Booking ID</span>
                <span class="booking-value">{{ decryptedBookingId }}</span>
              </div>
              <div class="row">
                <span class="label">Pick Up</span>
                <span class="value ml-20">{{ pickup }}</span>
              </div>
              <div class="row">
                <span class="label">Drop Off</span>
                <span class="value ml-20" >{{ destination }}</span>
              </div>
              <div class="row">
                <span class="label">Pick Up Due Time</span>
                <span class="booking-value">{{ bookingPickupTime }}</span>
              </div>
            </div>

            <!-- Service Selection Component - Only for Airport Bookings -->
            <ServiceSelection
              v-if="isAirportBooking  && !checkaccount && !is_archived && !payment_done_case"
              :services="serviceOptions"
              :selected-service-id="selectedServiceId"
              @select="handleServiceSelect"
            />

            <div v-if="manually_allowed_check">
              <div
                class="row"
                v-show="bookingStatus == 'active' || bookingStatus == 'booked' || bookingStatus == 'offered'"
              >
            
                <div v-if="admin_allow_third_party">
                  <div class="booking-confirmation" v-if="payment_done_case">
                    <div class="gradient-border">
                      <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                       <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                      <p>Booking ID: {{ decryptedBookingId }}</p>
                      <p>AuthCode: {{ authcode }}</p>

                      <p v-if="bookingStatus == 'booked' || bookingStatus == 'active' || bookingStatus == 'offered'">
                        PAID BEFORE JOURNEY
                      </p>
                      <p v-else v-show="showTracking">DRIVER CALLSIGN : {{ driverCallsign }}</p>

                    </div>

                    <div class="button-group">
                      <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                      <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                  </div>
                  <div v-else-if="checkaccount">
                    <h3>
                      {{ this.accountBookingText }}
                    </h3>
                     <div class="button-group">
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                  </div>
                  <div v-else-if="is_as_directed">
                    <h3>As directed booking not allowed</h3>
                  </div>
                  <div
                    v-else-if="
                      (!variable_cost && is_fixed_price && !checkaccount && (bookingStatus == 'active' || bookingStatus == 'offered'))
                      ||
                      ((bookingStatus == 'booked' || bookingStatus == 'offered') && !checkaccount)
                    "
                    class="panel panel-default widget-weather panel-body"
                  >
                    <div class="price-section" v-if="!isAirportBooking">
                      <div class="price-section-textbox">
                        <div class="price-section-text-div">
                          <p>
                            Your {{ amount_type }} Price
                          </p>
                        </div>

                      </div>
                      <div class="price-section-value-div">
                        <p>£ {{ amount }}</p>
                      </div>
                    </div>
                    <div ref="paymentForm" v-if="checkoutUrl || revolutOrderToken">
                      <div class="button-group">
                        <button class="pay-now" type="button" :disabled="isProcessingAirportPayment" @click.prevent="handleSubmit">
                          <span v-if="isProcessingAirportPayment" class="button-loader"></span>
                          <span v-if="isProcessingAirportPayment">Processing...</span>
                          <template v-else>
                            Pay Now <span v-if="isAirportBooking">{{ formattedSelectedPrice }}</span>
                          </template>
                        </button>

                        <button class="pay-now" @click.prevent="redirectToDownloadPage()">
                          Download App
                        </button>

                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                    </div>
                    <div v-if="showCharityDiv && (checkoutUrl || revolutOrderToken)">
                      <ul class="demo-alignment">
                        <li>
                          <vs-checkbox v-model="payForCharity" />
                        </li>
                        <li @click="openCharityDescription">
                          {{ charityText }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div v-else-if="variable_cost && !is_fixed_price && bookingStatus !='booked'">
                    <h3>
                      You have to wait till the journey comences as booking is
                      variable booking .
                    </h3>
                  </div>
                  <div
                    v-else-if="(payment_type == null || payment_type == 'Cash')"
                  >
                    <div class="mt-6 gap-4 flex justify-end">
                        <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                        <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                    <h4 class="flex justify-center mt-4">You want to pay by card ?</h4>
                    <div class="flex gap-4 justify-center mt-4">
                        <button class="pay-now" @click="payByCard">Yes </button>
                        <button  class="pay-now" > No </button>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <div class="booking-confirmation" v-if="payment_done_case">
                    <div class="gradient-border">
                      <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                       <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                      <p>Booking ID: {{ decryptedBookingId }}</p>
                      <p>AuthCode: {{ authcode }}</p>

                      <p v-if="bookingStatus == 'booked' || bookingStatus == 'active' || bookingStatus == 'offered'">
                        PAID BEFORE JOURNEY
                      </p>
                      <p v-else v-show="showTracking"> DRIVER CALLSIGN : {{ driverCallsign }}</p>

                    </div>
                    <div class="buttons">
                      <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                      <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                  </div>
                  <div v-else-if="is_as_directed">
                    <h3>As directed booking not allowed</h3>
                  </div>
                  
                  <div v-else-if="checkaccount">
                    <h3>
                      {{ this.accountBookingText }}
                    </h3>
                    <div class="button-group">
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                  </div>
                  <div
                    v-else-if="!variable_cost && is_fixed_price"
                    class="panel panel-default widget-weather panel-body"
                  >
                
                     <div class="price-section" v-if="!isAirportBooking">
                      <div class="price-section-textbox">
                        <div class="price-section-text-div">
                          <p>
                            Your {{ amount_type }} Price
                          </p>
                        </div>

                      </div>
                      <div class="price-section-value-div">
                        <p>£ {{ amount }}</p>
                      </div>
                    </div>
                    <div ref="paymentForm" v-if="checkoutUrl || revolutOrderToken">
                     <div class="button-group">
                        <button class="pay-now" type="button" :disabled="isProcessingAirportPayment" @click.prevent="handleSubmit">
                          <span v-if="isProcessingAirportPayment" class="button-loader"></span>
                          <span v-if="isProcessingAirportPayment">Processing...</span>
                          <template v-else>
                            Pay Now <span v-if="isAirportBooking">{{ formattedSelectedPrice }}</span>
                          </template>
                        </button>

                        <button class="pay-now" @click.prevent="redirectToDownloadPage()">
                          Download App
                        </button>
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                    </div>
                    <div
                      v-if="showCharityDiv && (checkoutUrl || revolutOrderToken)"
                      class="flex justify-center mt-7"
                    >
                      <ul class="demo-alignment">
                        <li>
                          <vs-checkbox v-model="payForCharity" />
                        </li>
                        <li @click="openCharityDescription">
                          {{ charityText }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div v-else-if="variable_cost && !is_fixed_price">
                    <h3>Third party booking not allowed .</h3>
                  </div>
                </div>
              </div>

              <div
                class="row"
                v-show="
                  bookingStatus == 'arrived' ||
                  bookingStatus == 'pickedup' ||
                  bookingStatus == 'dispatched'
                "
              >
                <div v-if="admin_allow_third_party">
                  <div v-if="is_fixed_price">
                    <div v-if="payment_done_case">
                      <div class="booking-confirmation">
                        <div class="gradient-border">
                          <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                          <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                          <p>Booking ID: {{ decryptedBookingId }}</p>
                          <p>AuthCode: {{ authcode }}</p>

                          <p  v-if="bookingStatus == 'booked' || bookingStatus == 'active' || bookingStatus == 'offered'">
                            PAID BEFORE JOURNEY
                          </p>
                          <p v-else v-show="showTracking">DRIVER CALLSIGN : {{ driverCallsign }}</p>

                        </div>
                        <div class="buttons">
                          <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                          <button class="track-btn"  v-show="showTracking &&  !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="checkaccount">
                      <h3>
                          {{ accountBookingText }}
                      </h3>
                      <div class="button-group">
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>

                    </div>
                    <div v-else>
                      <div
                        v-if="(payment_type == null || payment_type == 'Cash')"
                      >
                        <div class="mt-6 gap-4 flex justify-end">
                            <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                            <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                        </div>
                        <h4 class="flex justify-center mt-4">You want to pay by card ?</h4>
                        <div class="flex gap-4 justify-center mt-4">
                            <button class="pay-now" @click="payByCard">Yes </button>
                            <button  class="pay-now" > No </button>
                        </div>
                      </div>
                      <div v-else-if="payment_type == 'Card'">
                        <div
                          v-if="amount"
                          class="panel panel-default widget-weather panel-body"
                        >
                          <div class="price-section">
                            <div class="price-section-textbox">
                              <div class="price-section-text-div">
                                <p>
                                  Your {{ amount_type }} Price
                                </p>
                              </div>

                            </div>
                            <div class="price-section-value-div">
                              <p>£ {{ amount }}</p>
                            </div>
                          </div>
                          <div ref="paymentForm" v-if="checkoutUrl || revolutOrderToken">
                            <div class="button-group">
                              <button class="pay-now" type="button" @click.prevent="handleSubmit">Pay Now</button>

                              <button class="pay-now" @click.prevent="payCash"> Pay by Cash </button>

                              <button class="pay-now" @click.prevent="redirectToDownloadPage()">Download App </button>
                              <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>

                            </div>
                          </div>
                          <div v-if="showCharityDiv && (checkoutUrl || revolutOrderToken)">
                            <ul class="demo-alignment">
                              <li>
                                <vs-checkbox v-model="payForCharity" />
                              </li>
                              <li @click="openCharityDescription">
                                {{ charityText }}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div v-else>
                            <div class="payment-container">
                              <p class="payment-status">NOT PAID</p>
                              <p class="payment-message">
                                Please wait for the driver to send the price at the end of your journey. If the price isn't displayed please ask your driver to authorise your payment. It will display here
                              </p>
                              <div class="loading-spinner">
                                <span class="spinner"></span>
                              </div>
                              <p class="or-text">OR</p>
                              <div class="button-group">
                                <button class="pay-now" @click="payCash">Pay by Cash</button>
                                <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                                <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    <div class="booking-confirmation" v-if="payment_done_case">
                      <div class="gradient-border">
                        <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                         <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                        <p>Booking ID: {{ decryptedBookingId }}</p>
                        <p>AuthCode: {{ authcode }}</p>

                        <p  v-if="bookingStatus == 'booked' || bookingStatus == 'active' || bookingStatus == 'offered'">
                          PAID BEFORE JOURNEY
                        </p>
                        <p v-else v-show="showTracking">DRIVER CALLSIGN : {{ driverCallsign }}</p>

                      </div>
                      <div class="buttons">
                        <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                        <button class="track-btn"  v-show="showTracking &&  !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="is_locked && payment_type=='Card'"
                        class="panel panel-default widget-weather panel-body"
                      >
                         <div class="price-section">
                          <div class="price-section-textbox">
                            <div class="price-section-text-div">
                              <p>
                                Your {{ amount_type }} Price
                              </p>
                            </div>

                          </div>
                          <div class="price-section-value-div">
                            <p>£ {{ amount }}</p>
                          </div>
                        </div>
                        <div ref="paymentForm" v-if="checkoutUrl || revolutOrderToken">
                          <div class="button-group">
                            <button class="pay-now" type="button" @click.prevent="handleSubmit"> Pay Now </button>
                            <button class="pay-now" @click.prevent="payCash"> Pay by Cash </button>
                            <button class="pay-now" @click.prevent="redirectToDownloadPage()"> Download App </button>
                            <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver </button>
                          </div>
                        </div>
                        <div v-if="showCharityDiv && (checkoutUrl || revolutOrderToken)">
                          <ul class="demo-alignment">
                            <li>
                              <vs-checkbox v-model="payForCharity" />
                            </li>
                            <li @click="openCharityDescription">
                              {{ charityText }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div v-else-if="checkaccount">
                        <h3>
                          {{ this.accountBookingText }}
                        </h3>
                        <div class="button-group">
                            <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                        </div>
                      </div>
                      <div v-else-if="payment_type == null || payment_type == 'Cash'" >
                        <div class="mt-6 gap-4 flex justify-end">
                            <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                            <button class="track-btn"  v-show="showTracking  && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                        </div>
                        <h4 class="flex justify-center mt-4">You want to pay by card ?</h4>
                        <div class="flex gap-4 justify-center mt-4">
                            <button class="pay-now" @click="payByCard">Yes </button>
                            <button  class="pay-now" > No </button>
                        </div>
                      </div>
                      <div v-else>
                        <div class="payment-container">
                            <p class="payment-status">NOT PAID</p>
                            <p class="payment-message">
                              Please wait for the driver to send the price at the end of your journey. If the price isn't displayed please ask your driver to authorise your payment. It will display here
                            </p>
                            <div class="loading-spinner">
                              <span class="spinner"></span>
                            </div>
                            <p class="or-text">OR</p>
                            <div class="button-group">
                              <button class="pay-now" @click="payCash">Pay by Cash</button>
                              <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                              <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div v-else>
                  <div class="booking-confirmation" v-if="payment_done_case">
                    <div class="gradient-border">
                      <h4 class="mb-4">PLEASE SHOW THIS TO YOUR DRIVER</h4>
                      <p>Amount Paid: &#163; {{ bookingPaymentAmount }} </p>
                      <p>Booking ID: {{ decryptedBookingId }}</p>
                      <p>AuthCode: {{ authcode }}</p>
                      <p v-if="bookingStatus == 'booked' || bookingStatus == 'active' || bookingStatus == 'offered'">
                        PAID BEFORE JOURNEY
                      </p>
                      <p v-else v-show="showTracking">DRIVER CALLSIGN : {{ driverCallsign }}</p>

                    </div>
                    <div class="buttons">
                      <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                      <button class="track-btn"  v-show="showTracking  && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                  </div>
                  <div v-else-if="checkaccount">
                    <h3>
                      {{ this.accountBookingText }}
                    </h3>
                    <div class="button-group">
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                  </div>
                  <!-- <div
                    v-else-if="(payment_type == null || payment_type == 'Cash')"
                  >
                    <div class="mt-6 gap-4 flex justify-end">
                        <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                        <button class="track-btn"  v-show="showTracking && !is_archived" @click="redirectToLiveTrackingPage()">Track Driver</button>
                    </div>
                   dasda <h4 class="flex justify-center mt-4">You want to pay by card ?</h4>
                    <div class="flex gap-4 justify-center mt-4">
                        <button class="pay-now" @click="payByCard">Yes </button>
                        <button  class="pay-now" > No </button>
                    </div>
                  </div> -->
                  
                  <div
                    v-else
                    class="panel panel-default widget-weather panel-body"
                  >
                     <div class="price-section">
                      
                      <div class="price-section-textbox">
                        <div class="price-section-text-div">
                          <p>
                            Your {{ amount_type }} Price
                          </p>
                        </div>

                      </div>
                      <div class="price-section-value-div">
                        <p>£ {{ amount }}</p>
                      </div>
                    </div>
                    <div ref="paymentForm" v-if="checkoutUrl || revolutOrderToken">
                      <div class="button-group">
                        <button class="pay-now" type="button" @click.prevent="handleSubmit">Pay Now</button>

                        <button class="pay-now" @click.prevent="redirectToDownloadPage()">Download App</button>
                        <button class="track-btn" v-show="showTracking && !is_archived" @click.prevent="redirectToLiveTrackingPage()"> Track Driver</button>
                      </div>
                    </div>
                    <div v-if="showCharityDiv && (checkoutUrl || revolutOrderToken)">
                      <ul class="demo-alignment">
                        <li>
                          <vs-checkbox v-model="payForCharity" />
                        </li>
                        <li @click="openCharityDescription">
                          {{ charityText }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-show="bookingStatus == 'archived'">
                <p class="error">
                  You cannot edit, track or process a payment for this booking at this time as
                  it might be completed, cancelled or the driver could not find
                  you
                </p>
                <div class="buttons">
                  <button class="call-us" @click="callUs()">Call Us</button>
                  <button class="pay-now" @click="redirectToDownloadPage()">Download App</button>
                </div>
              </div>
            </div>
            
            <div
              v-else-if="
                !manually_allowed_check && manually_allowed_check != null
              "
            >
              Manual Booking Is Not Allowed To Do Payment
            </div>

          </div>

        </div>

    </div>
  </div>
    <vs-popup class="holamundo"  title="Edit Booking" :active.sync="editBookingPopup">
    <div class="booking-status-area">
      <div class="booking-status-text-area">
        <div class="booking-status-text-div">
          <p>{{ bookingStatus === "booked"
                ? "Advanced" : capitalizeFirst(bookingStatus) }} Booking {{payment_done_case? 'Paid':'UnPaid'}}</p>
        </div>
      </div>
    </div>
    <div>
      <form @submit.prevent="editBooking">
        <div class="vx-row sm:mb-4 mb-6 mob-view">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="ml-2  vs-input--label" for="">Date</label>
            <datepicker @input="onInputChange" :disabledDates="disabledDates" :disabled="!bookingEditableFields.date.visible"  v-model="bookingEditableFields.date.value" format="dd/MM/yyyy" placeholder="01/01/2025" input-class="vs-con-input-label vs-input w-full " calendar-class="vs-input"/>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="ml-2  vs-input--label" for="">Time</label>
            <input id="time" :disabled="!bookingEditableFields.time.visible" type="time" class="vs-con-input-label time-input vs-input--input normal w-full" v-model="bookingEditableFields.time.value" :min="timeMin" step="60"/>
          </div>
        </div>

        <div class="vx-row sm:mb-4 mb-6  mob-view-2">
          <div class="vx-col sm:w-1/2 w-full">
            <label class="ml-2 vs-input--label" for="">Pickup</label>
             <gmap-autocomplete
                    :disabled="!bookingEditableFields.pickup.visible"
                    ref="pickupAutocomplete"
                    class="vs-inputx vs-input--input normal w-full h-38"
                    @place_changed="setPlace"
                    label-placeholder="Pickup"
                    placeholder="Pickup"
                    name="pickup"
              ></gmap-autocomplete>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label class="ml-2 vs-input--label" for="">DropOff</label>
             <gmap-autocomplete
                    :disabled="!bookingEditableFields.dropOff.visible"
                    ref="dropoffAutocomplete"
                    class="vs-inputx vs-input--input normal w-full h-38"
                    @place_changed="setPlace2"
                    label-placeholder="DropOff"
                    placeholder="DropOff"
                    name="dropoff"
              ></gmap-autocomplete>
          </div>
        </div>
        <div class="vx-row sm:mb-4 mb-6  mob-view" v-show="showVehicleType">
          <div class="vx-col w-full">
            <label class="ml-2 vs-input--label" for="">Vehicle type</label>
          
            <v-select
              :disabled="!allow_vehicle_type_change || !bookingEditableFields.vehicleType.visible"
              :clearable="false"
              :options="vehicleTypeOptions"
              label="name"
              :reduce="option => option.id"
              v-validate="'required'"
              name="vehicleType"
              v-model="selectedVehicleTypeId"
            />
            <div
              v-if="nonBaseBookingCapabilities.length"
              class="non-base-capability-chips"
            >
              <span
                v-for="capability in nonBaseBookingCapabilities"
                :key="capability.id"
                class="non-base-capability-chip"
              >
                {{ capability.name }}
              </span>
            </div>
            </div>
        </div>
        <div class="vx-row sm:mb-4 mb-6 ">
          <div class="vx-col  w-full">
            <label class="ml-2 vs-input--label" for="">Name</label>
            <input class="vs-inputx vs-input--input normal w-full h-38" v-model="bookingEditableFields.name.value"/>
          </div>
        </div>
        <div class="vx-row mb-6" >
          <div class="vx-col  w-full vs-component vs-con-input-label vs-input" >
            <label class="ml-2  vs-input--label" for="">Driver notes</label>
            <textarea  v-model="bookingEditableFields.driverNotes.value" class="vs-inputx vs-input--input normal w-full" height="100px"  label="Driver notes" placeholder=""  />
          </div>
        </div>
      <vs-divider/>
      <vs-row class="mt-4 gap-4" vs-type="flex" vs-justify="space-between" >
      <button  class="cancel-btn" @click.prevent="editBookingPopup = false">  Cancel  </button>
      <button class="track-btn" type="submit">  Save  </button>
      </vs-row>

    </form>
    </div>

    </vs-popup>

  </div>
</template>

<script>
import autocabPromotionMixin from '../mixins/autocabPromotionMixin';
import ServiceSelection from '../components/ServiceSelection.vue';

export default {
  name: 'AutocabPromotion',
  components: {
    ServiceSelection
  },
  mixins: [autocabPromotionMixin],
  methods: {
    // Autocab uses default implementations from autocabPromotionMixin
    // All service selection logic is now in the mixin
  }
};
</script>

<style scoped>
@import "../../promot.css";

/* Increase right column card width */
.right-column .card {
  max-width: 700px !important;
  width: 100%;
}

/* Upgrade message styling */
.upgrade-message {
  font-size: 14px;
  color: #374151;
  margin-bottom: 20px;
  line-height: 1.5;
}

.non-base-capability-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.non-base-capability-chip {
  background-color: #e5e7eb;
  color: #6b7280;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  padding: 3px 10px;
  font-size: 12px;
  line-height: 1.3;
}
</style>

